import clsx from 'clsx';
import { memo } from 'react';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui/Stack';
import { TableCellDiv } from 'src/core/ui/TableCellDiv';
import { TableShimmeringDiv } from 'src/tables/Table/Table.styled';
import { getColorForValue } from 'src/utils/cellUtils';

import { BaseCell } from '../BaseCell';
import * as styles from './ConditionalCell.css';
import { ConditionalCellProps } from './ConditionalCell.types';

const ConditionalCellComponent = ({
  value,
  displayValue,
  thresholds = [],
  formatter,
  isLoading,
}: ConditionalCellProps) => {
  if (isLoading) {
    return <TableShimmeringDiv height="20px" />;
  }

  if (value == null || displayValue == null) {
    return <TableCellDiv align="right">-</TableCellDiv>;
  }
  const { backgroundColor, color } =
    thresholds.length > 0
      ? getColorForValue(value, thresholds)
      : {
          backgroundColor: 'neutral',
          color: vars.color.textPrimaryV2,
        };

  const formattedDisplayValue = formatter
    ? formatter(displayValue)
    : displayValue.toString();

  return (
    <BaseCell showPadding={false} isFullWidth>
      <div
        className={styles.conditionalCell}
        style={{ backgroundColor, color }}
      >
        <span>{formattedDisplayValue}</span>
      </div>
    </BaseCell>
  );
};

ConditionalCellComponent.displayName = 'ConditionalCell';

export const ConditionalCell = memo(ConditionalCellComponent);
